"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveUsersToGroup = exports.handleDeleteGroupsUsers = exports.handleDeleteUsers = exports.handleDeleteUsersFromProject = exports.handleUpdateUserProfile = exports.handleCreateUserProfile = exports.handleUpdateTRMVRMeter = exports.handleCreateTRMVRMeter = exports.handleUpdateWorksiteDiary = exports.handleCreateWorksiteDiary = exports.handleUpdateCategory = exports.handleDeleteGroup = exports.handleCreateCategory = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/project/members");
const Actions = require("../../actions/project/members");
const WizardActions = require("../../actions/project/wizard");
const errorHandling_1 = require("../../utils/errorHandling");
function handleCreateCategory(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_CATEGORY_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: {
                projectId: request.payload.projectId,
                name: request.payload.name,
                description: request.payload.description
            },
            url: `${baseUrl}api/project/${request.payload.projectId}/categories`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.createCategorySuccess(),
                Actions.toggleModal(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createCategoryFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleCreateCategory = handleCreateCategory;
function handleDeleteGroup(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DELETE_GROUP_REQUEST), (0, operators_1.mergeMap)((action) => {
        let url = `${baseUrl}api/project/${action.payload.projectId}/categories`;
        let body = {
            projectId: action.payload.projectId,
            categoryIds: [action.payload.group.id]
        };
        if (action.payload.group.type === 'NormalUserGroup' ||
            action.payload.group.type === 'SokoBidUserGroup' ||
            action.payload.group.type === 'LightAdminUserGroup') {
            url = `${baseUrl}api/project/${action.payload.projectId}/user-profiles`;
            body = {
                projectId: action.payload.projectId,
                userProfileIds: [action.payload.group.id]
            };
        }
        else if (action.payload.group.type === 'WorksiteDiaryUserGroup') {
            url = `${baseUrl}api/worksitediary/${action.payload.projectId}`;
            body = {
                worksitediaryUserGroupId: action.payload.group.id
            };
        }
        else if (action.payload.group.type === 'TRMVRUserGroup') {
            url = `${baseUrl}api/trmvrmeter/${action.payload.projectId}`;
            body = {
                trmvrmeterUserGroupId: action.payload.group.id
            };
        }
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'DELETE',
            body,
            url
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.deleteGroupSuccess(),
                Actions.UsergroupList.fetchRequest('PROJECT', action.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.deleteGroupFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleDeleteGroup = handleDeleteGroup;
function handleUpdateCategory(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_CATEGORY_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            body: request.payload,
            url: `${baseUrl}api/project/${request.payload.projectId}/categories`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.updateCategorySuccess(),
                Actions.toggleModal(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.updateCategoryFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleUpdateCategory = handleUpdateCategory;
// Worksite diary filters
function handleCreateWorksiteDiary(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_WORKSITE_DIARY_REQUEST), (0, operators_1.mergeMap)((request) => {
        const body = request.payload.worksitediarynumber
            ? {
                projectId: request.payload.projectId,
                name: request.payload.name,
                siteNumber: request.payload.worksitediarynumber
            }
            : {
                projectId: request.payload.projectId,
                name: request.payload.name
            };
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: body,
            url: `${baseUrl}api/worksitediary/${request.payload.projectId}`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.createWorksiteDiarySuccess(),
                Actions.toggleModal(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createWorksiteDiaryFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleCreateWorksiteDiary = handleCreateWorksiteDiary;
function handleUpdateWorksiteDiary(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_WORKSITE_DIARY_REQUEST), (0, operators_1.mergeMap)((request) => {
        const body = request.payload.worksitediarynumber
            ? {
                projectId: request.payload.projectId,
                name: request.payload.name,
                siteNumber: request.payload.worksitediarynumber
            }
            : {
                projectId: request.payload.projectId,
                name: request.payload.name
            };
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            body: body,
            url: `${baseUrl}api/worksitediary/${request.payload.worksitediaryId}`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.updateWorksiteDiarySuccess(),
                Actions.toggleModal(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.updateWorksiteDiaryFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleUpdateWorksiteDiary = handleUpdateWorksiteDiary;
// TRMVR Meter filters
function handleCreateTRMVRMeter(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_TRMVRMETER_REQUEST), (0, operators_1.mergeMap)((request) => {
        const body = request.payload.siteNumber
            ? {
                projectId: request.payload.projectId,
                name: request.payload.name,
                meterType: request.payload.meterType,
                siteNumber: request.payload.siteNumber
            }
            : {
                projectId: request.payload.projectId,
                name: request.payload.name,
                meterType: request.payload.meterType
            };
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: body,
            url: `${baseUrl}api/trmvrmeter/${request.payload.projectId}`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.createTRMVRMeterSuccess(),
                Actions.toggleModal(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createTRMVRMeterFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleCreateTRMVRMeter = handleCreateTRMVRMeter;
function handleUpdateTRMVRMeter(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_TRMVRMETER_REQUEST), (0, operators_1.mergeMap)((request) => {
        const body = request.payload.siteNumber
            ? {
                projectId: request.payload.projectId,
                name: request.payload.name,
                siteNumber: request.payload.siteNumber,
                meterType: request.payload.meterType
            }
            : {
                projectId: request.payload.projectId,
                name: request.payload.name,
                meterType: request.payload.meterType
            };
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            body: body,
            url: `${baseUrl}api/trmvrmeter/${request.payload.trmvrmeterId}`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.updateTRMVRMeterSuccess(),
                Actions.toggleModal(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.updateTRMVRMeterFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleUpdateTRMVRMeter = handleUpdateTRMVRMeter;
function handleCreateUserProfile(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_USER_PROFILE_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: {
                projectId: request.payload.projectId,
                categoryId: request.payload.categoryId,
                name: request.payload.name,
                description: request.payload.description,
                copiedProfileId: request.payload.copiedProfileId,
                validSince: request.payload.period &&
                    request.payload.period.validSince &&
                    request.payload.period.validSince.unix() * 1000,
                validUntil: request.payload.period &&
                    request.payload.period.validUntil &&
                    request.payload.period.validUntil.unix() * 1000
            },
            url: `${baseUrl}api/project/${request.payload.projectId}/user-profiles`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.createUserProfileSuccess(),
                Actions.toggleModal(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createUserProfileFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleCreateUserProfile = handleCreateUserProfile;
function handleUpdateUserProfile(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_USER_PROFILE_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            body: {
                projectId: request.payload.projectId,
                name: request.payload.name,
                description: request.payload.description,
                userProfileId: request.payload.userProfileId,
                copyType: request.payload.copyType,
                toCopy: request.payload.toCopy,
                validSince: request.payload.period &&
                    request.payload.period.validSince &&
                    request.payload.period.validSince.unix() * 1000,
                validUntil: request.payload.period &&
                    request.payload.period.validUntil &&
                    request.payload.period.validUntil.unix() * 1000
            },
            url: `${baseUrl}api/project/${request.payload.projectId}/user-profiles`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.updateUserProfileSuccess(),
                Actions.toggleModal(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.updateUserProfileFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleUpdateUserProfile = handleUpdateUserProfile;
function handleDeleteUsersFromProject(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DELETE_USERS_FROM_PROJECT_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'DELETE',
            body: request.payload,
            url: `${baseUrl}api/project/${request.payload.projectId}/members`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.deleteUsersFromProjectSuccess(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.deleteUsersFromProjectFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleDeleteUsersFromProject = handleDeleteUsersFromProject;
function handleDeleteUsers(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DELETE_USERS_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'DELETE',
            body: request.payload.items,
            url: `${baseUrl}api/project/${request.payload.projectId}/members`
        }).pipe((0, operators_1.mergeMap)(() => {
            const act = [
                Actions.deleteUsersSuccess(),
                Actions.UsergroupList.fetchRequest('PROJECT', request.payload.projectId)
            ];
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.deleteUsersFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleDeleteUsers = handleDeleteUsers;
const handleDeleteGroupsUsers = (action$, store, { ajax, getToken, baseUrl }) => action$.ofType(ActionTypes.DELETE_GROUPS_USERS_REQUEST).pipe((0, operators_1.mergeMap)((req) => ajax({
    url: `${baseUrl}api/project/${req.payload.projectId}/groups-users`,
    method: 'DELETE',
    headers: {
        Authorization: getToken(),
        'Content-Type': 'application/json'
    },
    body: req.payload
}).pipe((0, operators_1.mergeMap)(() => {
    const fetchRequest = req.payload.context === 'WIZARD'
        ? WizardActions.UsergroupList.fetchRequest
        : Actions.UsergroupList.fetchRequest;
    return (0, rxjs_1.of)(Actions.deleteUsersFromProjectSuccess(), fetchRequest('PROJECT', req.payload.projectId));
}), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.deleteGroupsUsersFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
exports.handleDeleteGroupsUsers = handleDeleteGroupsUsers;
const resolveMoveUsersRequestVariables = (baseUrl, type, request) => {
    return type === 'MOVE'
        ? {
            url: `${baseUrl}api/user-group/move-member`,
            body: {
                users: request.payload.users.map((user) => ({
                    userId: user.user,
                    currentGroupId: user.oldGroup
                })),
                targetGroupId: request.payload.group.id
            }
        }
        : {
            url: `${baseUrl}api/project/${request.payload.projectId}/copy-users`,
            body: {
                users: request.payload.users,
                group: request.payload.group.uuid
            }
        };
};
function moveUsersToGroup(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.MOVE_COPY_USER_TO_USER_GROUP_SAVE_REQUEST), (0, operators_1.mergeMap)((request) => {
        const type = store.value.project.members.moveOrCopy;
        const { projectId } = request.payload;
        const requestVars = resolveMoveUsersRequestVariables(baseUrl, type, request);
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: requestVars.body,
            url: requestVars.url
        }).pipe((0, operators_1.mergeMap)(() => {
            const actions = [
                Actions.moveCopyUsersToGroupSaveSuccess(),
                Actions.UsergroupList.fetchRequest('PROJECT', projectId)
            ];
            return (0, rxjs_1.merge)((0, rxjs_1.of)(...actions), (0, rxjs_1.of)(Actions.toggleMoveCopyUserToGroup(false)).pipe((0, operators_1.delay)(2000)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.moveCopyUsersToGroupSaveFailure(e))));
    }));
}
exports.moveUsersToGroup = moveUsersToGroup;
//# sourceMappingURL=members.js.map